module.exports = __webpack_public_path__ + "media/images/inner-pattern-banner-3086abc0b3f577c83893cee01224616a.png";